import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import styled from "styled-components";
import { CustomLeftArrow, CustomRightArrow } from "../Components/CustomArrows";

const ReviewCarousel = styled(Carousel)`
  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) {
    position: unset !important; // Override carousel default positioning
  }
`;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 5000, min: 0 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 2560, min: 0 },
    items: 1,
  },
  laptop: {
    breakpoint: { max: 1024, min: 0 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ReviewWrapper = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 0px 30px 30px 60px;
  padding: 0.9rem;
`;
const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 50px;
    height: 50px;
  }
`;
const AvatarWrapper = styled.div`
  display: flex;
`;
const UserName = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #0f1b38;
  width: fit-content;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    font-size: 19px;
  }
`;
const UserReviewText = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  margin-top: 0.4rem;
  margin-bottom: 0.7rem;
  text-align: left;
  color: #0f1b38;
  margin-left: 45px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    font-size: 17px;
    line-height: initial;
  }
`;

const RightSideWrapper = styled.div`
  dispaly: flex;
  flex-direction: column;
`;

const ReviewDate = styled.small`
  margin-left: 5px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;

  color: #919090;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    font-size: 14px;
  }
`;

const FooterLogo = styled.div`
  display: flex;
  justify-content: end;
`;

const LogoImage = styled.img`
  width: 60px;
  &:hover {
    cursor: pointer;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 115px;
  }
`;

const OwnerReplyWrapper = styled.div`
  margin-left: 2rem;
`;

const OwnerUsername = styled(UserName)`
  margin-bottom: 0.4rem;
`;
const RatingImage = styled.img`
  width: 80px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 100px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 115px;
  }
`;

function Reviews({ data }) {
  const [isImageZoomed, setIsImageZoomed] = useState(false);

  const handleImageLoadFail = (e) => {
    e.target.src = "images/default_avatar.png";
  };

  const YELP_LOGO_SRC_PATH =
    "images/yelp_logos/Logo/Light bg/RGB/yelp_logo.png";
  const GOOGLE_LOGO_SRC_PATH = "images/google_logos/google.png";

  const getLogo = (provider) => {
    if (provider == "Yelp") {
      return YELP_LOGO_SRC_PATH;
    }
    if (provider == "Google Reviews") {
      return GOOGLE_LOGO_SRC_PATH;
    }
  };

  const getRatingImageSrc = (review) => {
    let starFormatted = String(review.user.rating)
      .replace(".3", "_half")
      .replace(".4", "_half")
      .replace(".5", "_half")
      .replace(".6", "_half")
      .replace(".7", "_half");
    starFormatted = starFormatted
      .replace(".0", "")
      .replace(".1", "")
      .replace(".2", "");
    if (starFormatted.endsWith(".8") || starFormatted.endsWith(".9")) {
      starFormatted = Math.ceil(starFormatted);
    }
    if (review.provider == "Yelp") {
      return `images/yelp_stars/web_and_ios/regular/regular_${starFormatted}.png`;
    }
    if (review.provider == "Google Reviews") {
      return `images/google_stars/regular/regular_${starFormatted}.svg`;
    }
  };

  return (
    <ReviewCarousel
      className="ReviewCarousel"
      responsive={responsive}
      minimumTouchDrag={0}
      // autoPlay prop doesn't seem to work so that's why the autoPlaySpeed is set to 10h
      autoPlay={false}
      autoPlaySpeed={36000000}
      arrows
      customLeftArrow={<CustomLeftArrow specialsType="Review" />}
      customRightArrow={<CustomRightArrow specialsType="Review" />}
      swipeable={!isImageZoomed}
      draggable={!isImageZoomed}
    >
      {data.map((review, key) => {
        return (
          <ReviewWrapper className="ReviewWrapper" key={review.id}>
            <AvatarWrapper className="AvatarWrapper">
              <ProfileImage
                className="ProfileImage"
                onError={handleImageLoadFail}
                src={review.user.avatar_url}
              ></ProfileImage>
              <RightSideWrapper>
                <UserName>{review.user.name}</UserName>
                <RatingImage
                  src={getRatingImageSrc(review)}
                  alt="User Review Rating"
                />
                <ReviewDate>{review.user.review_date}</ReviewDate>
              </RightSideWrapper>
            </AvatarWrapper>
            <UserReviewText>{review.user.review_text}</UserReviewText>
            {review.owner.response_text && (
              <OwnerReplyWrapper>
                <UserReviewText>
                  <OwnerUsername>
                    Response from the owner
                    <ReviewDate>{review.owner.response_date}</ReviewDate>
                  </OwnerUsername>
                  {review.owner.response_text}
                </UserReviewText>
              </OwnerReplyWrapper>
            )}

            <FooterLogo>
              <LogoImage
                src={getLogo(review.provider)}
                alt={`${review.provider} Logo`}
                onClick={() => window.open(review.user.review_url, "_blank")}
              />
            </FooterLogo>
          </ReviewWrapper>
        );
      })}
    </ReviewCarousel>
  );
}

export default Reviews;
